<template>
  <div>
    <!-- <link
      href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet"
    /> -->
    <div :class="$x['payment-header-wrapper']">
      <div :class="$x['payment-header']" @click="headerClicked()">
        <h1>
          <span :class="$x['header-icon']">
            <ns-icon
              icon-name="icon-card"
              style="width: 20px; height: 20px; display: inline-block; margin-right: 5px; vertical-align: bottom;"
            />
            <ns-icon
              v-if="showComplete"
              icon-name="icon-circle-checkmark-med"
              style="width: 12px; height: 12px; position: relative; left: -11px; top: 6px;"
            />
          </span>
          <span>
            {{ t.billingSectionTitle }}
          </span>
        </h1>
        <span
          v-if="showEditLink()"
          :class="$x['edit-link']"
          @click="openPayments"
          ref="edit-link"
        >
          {{ t.edit }}
        </span>
      </div>
      <div v-if="showComplete" :class="$x['sub-header']">
        <img
          :class="$x['p-icon-large']"
          :src="getCardIcon(selectedPayment.paymentTypeId)"
        />
        <span
          v-if="!emptyPaymentFormName(selectedPayment.paymentTypeId)"
          name="paymentNumber"
        >
          {{ selectedPayment.paymentTypeDescription }}
          {{ selectedPayment.endingIn }}
          {{ getCcLastFour(selectedPayment.paymentNumber) }}
        </span>
      </div>
      <div v-if="showComplete" :class="$x['sub-header']">
        <ns-installment
          :value="selectedInstallment"
          :paymentId="selectedPaymentId"
          :payments="payments"
          :paymentTypes="allAvailablePaymentTypes"
          :label="t.installmentLabel"
          :installmentMessage="t.installmentMessage"
          @input="(installment) => selectedInstallment = installment"
        ></ns-installment>
        <p
          v-if="paymentMethodsInfo(selectedPayment.paymentTypeId, true)"
          v-html="sanitizeHTML(paymentMethodsInfo(selectedPayment.paymentTypeId, true))">
        </p>
        <div :class="$x['payment-message']" v-html="sanitizeHTML(checkoutStrings.paymentMessage)"></div>
      </div>
    </div>
    <div
      id="paymentWrapper"
      :class="$x['payment-wrapper']"
      data-app
      @click="totalClicks++"
    >
      <ns-alert
        v-for="a in alerts" :key="a.id"
        :class="$x['alert-payments']"
        type="card"
        :context="a.context"
        :title="a.title"
        visible
      >
        <template #body><span v-html="sanitizeHTML(a.message)"></span></template>
      </ns-alert>
      <section ref="collapsed-state" v-if="showSelectedPayment">
        <div>
          <div id="paymentNameText" :class="$x['payment-name']">
            {{ selectedPayment.paymentName }}
          </div>
          <div :class="$x['cc-info']">
            <img
              :class="$x['p-icon']"
              :src="getCardIcon(selectedPayment.paymentTypeId)"
            />
            <span
              v-if="!emptyPaymentFormName(selectedPayment.paymentTypeId)"
              name="paymentNumber"
            >
              {{ selectedPayment.paymentTypeDescription }}
              {{ selectedPayment.endingIn }}
              {{ getCcLastFour(selectedPayment.paymentNumber) }}
            </span>
          </div>
          <div
            v-if="selectedPayment.expiringSoon"
            :class="$x['cc-expiring']"
            name="expiration"
          >
            {{ t.expiring }} {{ selectedPayment.expiring }}
          </div>
          <div
            v-if="selectedPayment.expired"
            :class="$x['cc-expired']"
            name="expired"
          >
            <div v-if="!selectedPayment.editExpirationDate">
              <ns-icon
                icon-name="icon-error-lg"
                style="width: 20px; height: 20px; display: inline-block; margin-right: 5px; vertical-align: bottom;"
              />
              <span>{{ t.expired }} {{ selectedPayment.expired }} </span>
              <span
                ref="update-expiration-date-link"
                :class="[$x['update-expired-date'], $x.lnk]"
                @click="toggleExpirationDateForm(selectedPayment)"
                >{{ t.update }}</span
              >
            </div>
          </div>
          <div v-if="selectedPayment.editExpirationDate" :class="$x['expiration-date-form-wrapper']">
            <ns-expire-date-form
                    :class="$x['expirationDateForm']"
                    :translations="t"
                    @input="updateExpirationDate(selectedPayment, $event)"
            ></ns-expire-date-form>
            <button
                    :class="$x['close-expiration-form']"
                    name="closeExpirationForm"
                    @click="toggleExpirationDateForm(selectedPayment)"
            >
              <ns-icon
                      icon-name="icon-close"
                      style="width: 20px; height: 20px; display: inline-block; margin-right: 5px; vertical-align: bottom;"
              />
            </button>
          </div>
          <ns-installment
            :value="selectedInstallment"
            :paymentId="selectedPaymentId"
            :payments="payments"
            :paymentTypes="allAvailablePaymentTypes"
            :label="t.installmentLabel"
            :installmentMessage="t.installmentMessage"
            @input="(installment) => selectedInstallment = installment"
          ></ns-installment>
          <div :class="$x['divider']"></div>
          <ns-cvv-form
            id="cvvForm"
            v-if="selectedPayment.cvvRequired && !!!cvv && !!!selectedPayment.expired"
            :value="cvv"
            :translations="t"
            :amex="selectedPayment.paymentTypeId===3"
            @input="setCvv"
          ></ns-cvv-form>
          <div class="sepa-radios"
               v-if="enableEmandates && selectedPayment.paymentTypeId === 54">
            <v-radio-group v-model="mandateType">
              <v-radio
                :class="$x['mandate-option']"
                value="electronic"
                :ripple="false"
                :label="checkoutStrings.electronicMandateLabel"
              ></v-radio>
              <v-radio
                :class="$x['mandate-option']"
                value="paper"
                :ripple="false"
                :label="checkoutStrings.paperMandateLabel"
              ></v-radio>
            </v-radio-group>
          </div>
          <p :class="$x['payment-message']" v-html="sanitizeHTML(checkoutStrings.paymentMessage)"></p>
        </div>

      </section>
      <section ref="expanded-state" v-if="showSavedPayments">
        <div :class="$x['choose-payment-icon']">
          <h2 :class="$x['add-payment-title']" class="subtitle-medium-semibold">
            {{ t.addNewPaymentSectionTitle }}
          </h2>
          <p v-show="t.choosePaymentType">{{ t.choosePaymentType }}</p>
          <span v-for="c in groupedCreditTypes" :key="c.id">
            <img
              :class="$x['p-icon']"
              :src="getCardIcon(c.id)"
              @click="openAddPaymentAndSetPaymentType(0)"
              :name="c.ofsId"
            />
          </span>
          <span v-for="c in availableSimvTypes" :key="c.id">
            <img
              :class="$x['p-icon']"
              :src="getCardIcon(c.id)"
              @click="openAddPaymentAndSetPaymentType(c.id)"
              :name="c.ofsId"
            />
          </span>
          <span v-for="c in availableCarteBleueTypes" :key="c.id">
            <img
              :class="$x['p-icon']"
              :src="getCardIcon(c.id)"
              @click="openAddPaymentAndSetPaymentType(c.id)"
              :name="c.ofsId"
            />
          </span>
          <span v-for="p in availablePaymentTypes" :key="p.id">
            <img
              :src="getCardIcon(p.id)"
              @click="openAddPaymentAndSetPaymentType(p.id)"
              :name="p.ofsId"
              :class="[
                $x['p-icon']
              ]"
            />
          </span>
        </div>
        <div :class="$x['saved-payments-header']">
          <h2 class="title-small-bold">
            <span>{{ t.savedPaymentMethods }}</span>
          </h2>
          <h3
            :class="[$x['add-payment'], canAddPayment() ? $x.lnk : $x['no-lnk']]"
            @click="openAddPayment('addPaymentLink')"
            data-testid="addPayment"
          >
            <ns-icon icon-name="icon-add" size="icon-lg" /> {{ t.add }}
          </h3>
        </div>
        <div v-if="payments.length === 0">{{ t.noSavedPayments }}</div>
        <v-radio-group v-model="selectedPaymentId">
          <div v-for="p in payments" :key="p.bePaymentTypeId" :class="$x['payment-selector']">
            <div>
              <v-radio
                :class="$x['saved-payment']"
                :value="p.bePaymentTypeId"
              >
                <template slot="label">
                  <div>
                    <h3 name="paymentName">{{ p.paymentName }}</h3>
                    <div :class="$x['cc-info']">
                      <img
                        :class="$x['p-icon']"
                        :src="getCardIcon(p.paymentTypeId)"
                      />
                      <span
                        v-if="!emptyPaymentFormName(p.paymentTypeId)"
                        name="paymentNumber"
                      >
                        {{ p.paymentTypeDescription }}
                        {{ t.endingIn }}
                        {{ getCcLastFour(p.paymentNumber) }}
                      </span>
                    </div>
                    <div
                      v-if="p.expiring"
                      :class="$x['cc-expiring']"
                      name="expiration"
                    >
                      {{ t.expiring }} {{ p.expiring }}
                    </div>
                    <div
                      v-if="p.expired"
                      :class="$x['cc-expired']"
                      name="expired"
                    >
                      <div v-if="!p.editExpirationDate">
                        <ns-icon
                          icon-name="icon-error-lg"
                          style="width: 20px; height: 20px; display: inline-block; margin-right: 5px; vertical-align: bottom;"
                        />
                        <span>{{ t.expired }} {{ p.expired }} </span>
                        <span
                          :class="[$x['update-expired-date'], $x.lnk]"
                          @click="toggleExpirationDateForm(p)"
                        >
                          {{ t.update }}
                        </span>
                      </div>
                    </div>
                    <div
                      v-if="p.defaultPayment"
                      :class="$x['cc-default']"
                      name="defaultPmt"
                    >
                      <ns-icon
                        icon-name="icon-checkmark"
                        style="width: 20px; height: 20px; display: inline-block; margin-right: 5px"
                      />
                      <span>{{ t.defaultPayment }}</span>
                    </div>
                    <div class="sepa-radios"
                         v-if="enableEmandates && selectedPaymentId === p.bePaymentTypeId && p.paymentTypeId === 54">
                      <v-radio-group v-model="mandateType">
                        <v-radio
                                :class="$x['mandate-option']"
                                value="electronic"
                                :ripple="false"
                                :label="checkoutStrings.electronicMandateLabel"
                        ></v-radio>
                        <v-radio
                                :class="$x['mandate-option']"
                                value="paper"
                                :ripple="false"
                                :label="checkoutStrings.paperMandateLabel"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                    <div
                      v-if="emptyPaymentFormName(p.paymentTypeId) && p.paymentTypeDescription"
                    >
                      <p v-html="sanitizeHTML(p.paymentTypeDescription)"></p>
                    </div>
                    <div
                      v-if="!p.expired && p.cvvRequired && selectedPaymentId === p.bePaymentTypeId"
                    >
                      <ns-cvv-form
                        buttonless
                        :id="p.bePaymentTypeId"
                        :translations="t"
                        :amex="p.paymentTypeId===3"
                        :value="cvv"
                        @input="setCvv"
                      ></ns-cvv-form>
                    </div>
                  </div>
                </template>
              </v-radio>
              <div
                v-show="p.editExpirationDate && selectedPaymentId === p.bePaymentTypeId"
                :class="$x['expiration-date-form-wrapper']"
              >
                <ns-expire-date-form
                  :class="$x['expirationDateForm']"
                  :translations="t"
                  @input="updateExpirationDate(p, $event)"
                ></ns-expire-date-form>
                <button
                  :class="$x['close-expiration-form']"
                  name="closeExpirationForm"
                  @click="toggleExpirationDateForm(p)"
                >
                  <ns-icon
                    icon-name="icon-close"
                    style="width: 20px; height: 20px; display: inline-block; margin-right: 5px; vertical-align: bottom;"
                  />
                </button>
              </div>
            </div>
            <div v-if="p.bePaymentTypeId != addedPaymentId" :class="$x['payment-selector-menu']">
              <v-menu attach left light content-class="pop-menu">
                <template v-slot:activator="{ on }">
                  <!-- It seems that the activator clicks are not captured by the payment-wrapper @click event
                       so we update the totalClicks here when the menu is clicked-->
                  <button
                    :class="$x['action-button']"
                    name="editMenu"
                    v-on="on"
                    @click="totalClicks++"
                  >
                    <ns-icon icon-name="icon-menu-dots" />
                  </button>
                </template>
                <v-list>
                  <v-list-tile
                    v-if="p.canEdit == true"
                    @click="openEditPayment(p)"
                    name="editPayment"
                  >
                    <v-list-tile-avatar>
                      <ns-icon icon-name="icon-edit" />
                    </v-list-tile-avatar>
                    <v-list-tile-title>{{ t.edit }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    @click="openDeleteConfirmation(p.bePaymentTypeId)"
                    name="deletePayment"
                  >
                    <v-list-tile-avatar>
                      <ns-icon icon-name="icon-trashcan" />
                    </v-list-tile-avatar>
                    <v-list-tile-title>{{ t.delete }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    v-if="p.bePaymentTypeId > 0"
                    @click="doUpdateDefaultPayment(p)"
                    name="updateDefault"
                  >
                    <v-list-tile-avatar>
                      <ns-icon icon-name="icon-checkmark" />
                    </v-list-tile-avatar>
                    <v-list-tile-title>{{
                      t.setAsDefault
                    }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
          </div>
        </v-radio-group>
        <div :class="[$x['add-payment'], $x.btn]">
          <button class="hit-solid fluid" @click="publishSelectedPayment()" name="publishSelectedPayment">
            {{ t.continue }}
          </button>
        </div>
      </section>
      <section id="editPaymentSection" v-show="showEditPayment">
        <h2 class="subtitle-medium-semibold" :class="$x['edit-payment-title']">
          <span>{{ t.editPaymentSectionTitle }}</span>
          <button @click="cleanupAddEditPayment()">
            <ns-icon icon-name="icon-close-x" />
          </button>
        </h2>
        <ns-credit-card-form
          ref="editCreditCardForm"
          v-model="currentEditedPayment"
          style="max-width: 500px"
          edit-mode
          :class="$x['credit-card-form']"
          :translations="t"
          :available-payments="formCreditTypes"
          :prevent-jcb-bin="true"
        />
        <div :class="$x['border-top']" v-if="withAddress">
          <ns-address-form
            v-model="addressFormData"
            ref="editAddressForm"
            :lang="language"
            :translations="t.address"
            :editing="editingBillingAddress"
            @editing="setEditingBillingAddress"
            @address-valid="setAddressFormValid"
          ></ns-address-form>
        </div>
        <div v-show="!editingBillingAddress">
          <div :class="$x['border-top']">
            <v-checkbox
              v-if="!hideSaveCheckboxes()"
              v-model="agreeToSave"
              :disabled="currentEditedPayment.bePaymentTypeId > 0"
              color="#7123D9"
            >
              <template slot="label">
                {{ t.agreeToSavePaymentType }}
              </template>
            </v-checkbox>
            <v-checkbox v-if="!hideSaveCheckboxes() && !hideDefaultCheckbox()" v-model="setAsDefault" :disabled="!agreeToSave" color="#7123D9">
              <template slot="label">{{ t.setAsDefault }}</template>
            </v-checkbox>
            <p v-if="enableStoredCredentials" :class="[$x['tac'], $x['message']]">
              {{ t.agreeToTermsOfUseMessage }} <a :href="termsOfUseLnk" :class="[$x.lnk]" target="_blank">{{t.termsOfUse}}</a>
            </p>
            <button
              class="alert-ghost"
              type="button"
              @click="
                openDeleteConfirmation(currentEditedPayment.bePaymentTypeId)
              "
              name="openDeleteConfirmation"
            >
              <ns-icon icon-name="icon-trashcan" />{{ t.deletePaymentMethod }}
            </button>
          </div>
          <div :class="$x['border-top']">
            <ns-alert
              v-for="a in alerts" :key="a.id"
              :class="[$x.alert, $x.mobile]"
              type="card"
              :context="a.context"
              :title="a.title"
              visible
            >
              <template #body><span v-html="sanitizeHTML(a.message)"></span></template>
            </ns-alert>
            <v-btn
              :loading="editSaveLoading"
              class="v-btn-hit-solid fluid form-save"
              name="saveEditPayment"
              @click="doSavePayment(currentEditedPayment)"
            >
              {{ t.save }}
            </v-btn>
            <button
              class="hit-outline fluid"
              name="cancelEditPayment"
              @click="cleanupAddEditPayment()"
            >
              {{ t.cancel }}
            </button>
          </div>
        </div>
      </section>
      <section id="addPaymentSection" v-if="showAddNewPayment">
        <div :class="$x.contents">
          <div :class="$x.left">
            <h2
              class="subtitle-medium-semibold"
              :class="$x['add-payment-title']"
            >
              {{ t.addNewPaymentSectionTitle }}
            </h2>
            <v-radio-group v-model="selectedPaymentType">
              <!-- this is a hack because v-radio is garbage and doesn't work -->
              <div v-if="groupedCreditTypes.length > 0" class="radio-option" @click="selectedPaymentType = 0">
                <v-radio
                  name="payment-type-cc"
                  class="subtitle-small-semibold"
                  :value="0"
                  color="#7123D9"
                ></v-radio>
                <span class="label">{{ t.creditOption }}</span>
              </div>
              <div v-if="groupedCreditTypes.length > 0" :class="$x['card-icons']">
                <img
                  :class="$x['p-icon']"
                  v-for="c in groupedCreditTypes"
                  :key="c.id"
                  :src="getCardIcon(c.id)"
                  @click="selectedPaymentType = 0"
                />
              </div>
              <div v-for="p in availableSimvTypes" :key="p.id">
                <div class="radio-option" @click="selectedPaymentType = p.id">
                  <v-radio
                    :value="p.id"
                    :name="'payment-type-' + p.id"
                    color="#7123D9"
                  ></v-radio>
                  <span class="label">{{ p.localizedName }}</span>
                </div>
                <div :class="$x['card-icons']">
                  <img
                    :class="$x['p-icon']"
                    :src="getCardIcon(p.id)"
                    @click="selectedPaymentType = p.id"
                  />
                </div>
              </div>
              <div v-for="p in availableCarteBleueTypes" :key="p.id">
                <div class="radio-option" @click="selectedPaymentType = p.id">
                  <v-radio
                    :value="p.id"
                    :name="'payment-type-' + p.id"
                    color="#7123D9"
                  ></v-radio>
                  <span class="label">{{ p.localizedName }}</span>
                </div>
                <div :class="$x['card-icons']">
                  <img
                    :class="$x['p-icon']"
                    :src="getCardIcon(p.id)"
                    @click="selectedPaymentType = p.id"
                  />
                </div>
              </div>
              <div v-for="p in availablePaymentTypes" :key="p.id">
                <div class="radio-option" @click="selectedPaymentType = p.id">
                  <v-radio
                    :value="p.id"
                    :name="'payment-type-' + p.id"
                    color="#7123D9"
                  ></v-radio>
                  <span class="label">{{ p.localizedName }}</span>
                </div>
                <div :class="$x['card-icons']">
                  <img
                    :class="$x['p-icon']"
                    :src="getCardIcon(p.id)"
                    @click="selectedPaymentType = p.id"
                  />
                </div>
              </div>
            </v-radio-group>
          </div>
          <div :class="$x.right">
            <ns-sepa-form
              ref="sepaForm"
              v-if="selectedPaymentType == 54"
              v-model="formData.cardNumber"
              :name="accountHolderName"
              :country="country"
              :class="$x['credit-card-form']"
              :translations="t"
              style="max-width: 500px"
            ></ns-sepa-form>
            <ns-cedyna-form
              ref="cedynaForm"
              v-if="selectedPaymentType == 98"
              v-model="formData"
              :class="$x['credit-card-form']"
              :payment-type-id="formData.paymentTypeId"
              :translations="t"
              :available-payments="availableCedynaTypes"
              style="max-width: 500px"
            ></ns-cedyna-form>
            <ns-credit-card-form
              ref="addCreditCardForm"
              v-if="isCreditCardPaymentType(selectedPaymentType)"
              v-model="formData"
              style="max-width: 500px"
              :class="$x['credit-card-form']"
              :translations="t"
              :available-payments="formCreditTypes"
              :prevent-jcb-bin="true"
            />
            <div
              id="otherPaymentInfo"
              v-if="emptyPaymentFormName(selectedPaymentType)"
            >
              <h2 class="subtitle-medium-semibold">
                {{ selectedPaymentTypeLocalizedName }}
              </h2>
              <img
                :class="$x['p-icon-large']"
                :src="getCardIcon(selectedPaymentType)"
              />
              <p v-html="sanitizeHTML(paymentMethodsInfo(selectedPaymentType))"></p>
            </div>
            <div :class="$x['border-top']" v-if="withAddress">
              <ns-address-form
                v-model="addressFormData"
                ref="addAddressForm"
                :lang="language"
                :translations="t.address"
                :editing="editingBillingAddress"
                @editing="setEditingBillingAddress"
                @address-valid="setAddressFormValid"
              ></ns-address-form>
            </div>
            <div v-show="!editingBillingAddress">
              <div v-if="!hideSaveCheckboxes()" :class="$x['border-top']">
                <v-checkbox
                  v-model="agreeToSave"
                  name="agreeToSave"
                  color="#7123D9"
                  :disabled="checkOrderTypeIsADR()"
                >
                  <template slot="label">
                    {{ t.agreeToSavePaymentType }}
                  </template>
                </v-checkbox>
                <v-checkbox
                  v-if="!hideDefaultCheckbox()"
                  v-model="setAsDefault"
                  name="setAsDefault"
                  color="#7123D9"
                  :disabled="!agreeToSave"
                >
                  <template slot="label">{{ t.setAsDefault }}</template>
                </v-checkbox>
                <p v-if="enableStoredCredentials" :class="[$x['tac'], $x['message']]">
                  {{ t.agreeToTermsOfUseMessage }} <a :href="termsOfUseLnk" :class="[$x.lnk]" target="_blank">{{t.termsOfUse}}</a>
                </p>
              </div>
              <div :class="$x['border-top']">
                <ns-alert
                  v-for="a in alerts" :key="a.id"
                  :class="[$x.alert, $x.mobile]"
                  type="card"
                  :context="a.context"
                  :title="a.title"
                  visible
                >
                  <template #body><span v-html="sanitizeHTML(a.message)"></span></template>
                </ns-alert>
                <v-btn
                  class="v-btn-hit-solid fluid form-save"
                  :loading="saveLoading"
                  @click="doSavePayment(formData)"
                  name="saveAddPayment"
                  :disabled="savePaymentProcessing"
                >
                  {{ t.save }}
                </v-btn>
                <button
                  class="hit-outline fluid"
                  name="cancelAddPayment"
                  v-on:click="cleanupAddEditPayment()"
                >
                  {{ t.cancel }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div>
        <v-dialog v-model="deleteConfirm" content-class="delete-confirmation">
          <v-card>
            <v-card-title class="title-small-bold">{{
              t.confirmDeletePayment
            }}</v-card-title>
            <v-card-actions>
              <button
                class="inverse-solid short"
                @click="deleteConfirm = false"
                name="cancelDelete"
              >
                {{ t.cancel }}
              </button>
              <button
                class="alert-solid short"
                @click="doDeletePayment()"
                name="confirmDelete"
              >
                {{ t.delete }}
              </button>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
  VCard,
  VCardActions,
  VCardTitle,
  VDialog,
  VList,
  VListTile,
  VListTileTitle,
  VListTileAvatar,
  VMenu,
  VRadioGroup,
  VRadio,
  VCheckbox,
  VBtn
} from "vuetify/lib";
import { events } from "@nuskin/ns-util";
import { NsAddressForm } from '@nuskin/smart-common-components';
import {
  NsCvvForm,
  NsIcon,
  NsCreditCardForm,
  NsAlert,
  PaymentType,
  NsSepaForm,
  NsCedynaForm,
  NsExpireDateForm
} from "@nuskin/design-components";
import NsInstallment from "./NsInstallment.vue";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "vuetify/dist/vuetify.min.css";
import PAYMENT_MIXIN from "./paymentMixin";

const PAYMENTERROR = "paymentError";

const COMPLETE_STATE = "complete";
const COLLAPSED_STATE = "collapsed";
const SELECT_PAYMENT_STATE = "select-payment";
const EDIT_PAYMENT_STATE = "edit-payment";
const ADD_PAYMENT_STATE = "add-payment";

const STATE = "state";
const EDIT = "edit";
const COMPLETE = "complete";
const CVV = "cvv";

const ERROR = 'error';

export default {
  name: "NsPaymentSelector",
  components: {
    NsIcon,
    NsCvvForm,
    NsCreditCardForm,
    NsCedynaForm,
    NsSepaForm,
    VBtn,
    VCard,
    VCardActions,
    VCardTitle,
    VDialog,
    VMenu,
    VList,
    VListTile,
    VListTileTitle,
    VListTileAvatar,
    VRadioGroup,
    VRadio,
    VCheckbox,
    NsAlert,
    NsAddressForm,
    NsExpireDateForm,
    NsInstallment
  },
  mixins: [PAYMENT_MIXIN],
  props: {
    /**
     * Will contain the selected payment when complete.  A payment
     * could be passed into the component here as well.
     * For non credit card type all you need is {paymentTypeId: value}
     * If it is not a saved payment it will save it and then select it
     */
    initialValue: {
      type: String,
      default() {
        return null;
      }
    },
    billingAddress: {
      type: String,
      default() {
        return null;
      }
    },
    creditOnly: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      addMethod: null,
      addedPaymentId: -1,
      addressFormData: null,
      addressFormValid: false,
      agreeToSave: true,
      alerts: [],
      currentEditedPayment: {},
      cvv: "",
      mandateType: 'electronic',
      selectedBillingAddress: null,
      deleteConfirm: false,
      editingBillingAddress: false,
      editSaveLoading: false,
      saveLoading: false,
      formData: {},
      rules: {},
      savePaymentProcessing: false,
      selectedInstallment: null,
      selectedPayment: null,
      selectedPaymentId: null,
      setAsDefault: false,
      showAddNewPayment: false,
      showCollapsedCvvForm: false,
      showComplete: false,
      showEditPayment: false,
      showSavedPayments: false,
      showSelectedPayment: false
    };
  },
  computed: {
    selectedPaymentTypeLocalizedName: function() {
      let paymentType;
      if (this.selectedPaymentType !== 0) {
        paymentType = this.availablePaymentTypes.find(
          p => this.selectedPaymentType === p.id
        );
      }
      return paymentType ? paymentType.localizedName : "";
    }
  },
  watch: {
    selectedPaymentType(newValue, oldValue) {
      this.setFormCreditTypes(newValue);
      this.withAddress = this.paymentTypeIsWithAddress(newValue);
      this.addressFormData = this.getBillingAddress(this.showAddNewPayment ? this.selectedBillingAddress : null);
      this.setEditingBillingAddress(this.withAddress && this.editingBillingAddress);

      if (!this.samePaymentType(newValue, oldValue)) {
        this.resetForms();
        this.formData = {};
      }
    },
    billingAddress(newValue) {
      newValue = JSON.parse(newValue);
      if (newValue && newValue.shippingCity) {
        this.selectedBillingAddress = this.adaptToBillingAddress(newValue);
        // If we are adding a new payment and the user saved a shipping address
        if (this.showAddNewPayment) {
          this.addressFormData = this.getBillingAddress(this.selectedBillingAddress);
        }
      }
    },
    selectedPaymentId(newValue, oldValue) {
      if (oldValue) {
        this.cvv = '';
        this.setExtraFieldsOnPayment(oldValue);
      }
      if (newValue) {
        this.selectedInstallment = null;
        this.setExtraFieldsOnPayment(newValue);
      }
    },

    agreeToSave() {
      if (!this.agreeToSave) {
        this.setAsDefault = false;
      }
    },

    t() {
      if (Object.keys(this.t).length > 0) {
        this.rules = {
          required: value => !!value || this.t.fieldRequired,
          cvv: value => /^\d{1,4}$/.test(value) || this.t.cvvInvalid
        };
      }
    },

    selectedInstallment(newValue) {
      const pmt = this.payments.find(pmt => pmt.bePaymentTypeId === this.selectedPaymentId);

      if (pmt) {
        pmt.installmentSelectedNumber = newValue;
        pmt.useInstallments = newValue != null;
        this.publishSelectedPayment();
      }
    }
  },
  methods: {
    headerClicked() {
      console.log("HEADER CLICKED");
    },

    /**
     *  show the edit link if there is an editable payment type (credit, cedyna)
     *  or there is more than 1 paymentType with no form
     *  availablePaymentTypes will be 0 if they saved them
     *  so looks at saved payments as well
    */
    showEditLink() {
      return (this.availableCreditTypes.length > 0 ||
              this.availableCedynaTypes.length > 0 ||
              this.availablePaymentTypes.length + this.payments.length > 1) &&
              (this.showComplete || this.showSelectedPayment);
    },

    setCvv(value) {
      this.cvv = value;
      this.setState();
    },

    paymentMethodsInfo(paymentTypeId, summarized = false) {
      let info = '';
      if (this.emptyPaymentFormName(paymentTypeId)) {
        let paymentType = this.additionalPaymentMethodsInfo.find(
          p => paymentTypeId === parseInt(p.paymentTypeId)
        );
        if (paymentType) {
          info = summarized ? paymentType.paymentMethodShortDesc || paymentType.paymentMethodText : paymentType.paymentMethodText;
        } else if (this.selectedPayment) {
          info = this.selectedPayment.paymentName;
        }
      }
      return info;
    },

    async publishSelectedPayment() {
      if (this.selectedPaymentId) {
        let pmt = this.payments.find(
          p => p.bePaymentTypeId === this.selectedPaymentId,
          this
        );
        if (pmt.paymentTypeId === PaymentType.SDD && this.enableEmandates) {
          pmt.mandateType = this.mandateType;
        }
        if (!pmt.cvvRequired || this.cvv) {
          this.selectedPayment = pmt;
          this.setState();
        }
      }
    },

    openEditPayment(payment) {
      this.withAddress = this.paymentTypeIsWithAddress(payment.paymentTypeId);
      this.currentEditedPayment = this.getPaymentData(payment);
      this.addressFormData = this.getBillingAddress(payment);
      this.agreeToSave = this.hideSaveCheckboxes() ? false : payment.bePaymentTypeId > 0;
      this.setAsDefault = payment.defaultPayment;
      this.showState(EDIT_PAYMENT_STATE);

      setTimeout(
        scope => {
          this.$nextTick(() => document.getElementById("editPaymentSection").scrollIntoView());
          scope.$refs.editCreditCardForm.validate();
        },
        125,
        this
      );
    },

    hideSaveCheckboxes() {
      return this.isGuest || (this.emptyPaymentFormName(this.selectedPaymentType) && !this.saveNonCreditCards);
    },

    openDeleteConfirmation(paymentId) {
      this.deletePaymentId = paymentId;
      this.deleteConfirm = true;
    },

    async doDeletePayment() {
      this.deleteConfirm = false;
      // To call the paymentservice we need a loggedin user and the payment must be saved
      const deleted = await this.deletePayment(this.deletePaymentId, this.showEditPayment);
      if (deleted) {
        if (this.showEditPayment) {
          this.cleanupAddEditPayment();
        }
      }
    },

    async getAddressFormData() {
      if (!this.selectedBillingAddress && !(this.defaultShippingAddress && this.defaultShippingAddress.city)) {
        await this.getDefaultBillingAddress();
      }
      return this.getBillingAddress(this.selectedBillingAddress || this.defaultShippingAddress);
    },

    openAddPayment(addMethod, initializing = false) {
      if (this.canAddPayment()) {
        this.addMethod = addMethod;
        this.showState(ADD_PAYMENT_STATE);
        this.agreeToSave = !this.hideSaveCheckboxes();
        this.selectedPaymentType = this.getFirstAvailablePaymentType();
        setTimeout(
          async scope => {
            if (!initializing) {
              this.$nextTick(() => document.getElementById("addPaymentSection").scrollIntoView());
            }

            if (scope.withAddress) {
              scope.addressFormData = await this.getAddressFormData();
            }
          },
          125,
          this
        );
      }
    },

    openAddPaymentAndSetPaymentType(id, method = 'addPaymentIcon', initializing = false) {
        this.openAddPayment(method, initializing);
        this.selectedPaymentType = id;
    },

    setEditingBillingAddress(editingAddress) {
      this.editingBillingAddress = editingAddress;
    },

    setAddressFormValid(isValid) {
      this.addressFormValid = isValid;
    },

    async doUpdateDefaultPayment(payment) {
      let defaultStatus = payment.defaultPayment;

      try {
        this.updateDefaultPayment(payment, "defaultMenuOption");
      } catch (err) {
        payment.defaultPayment = defaultStatus;
        this.addToAlerts();
        events.tag(PAYMENTERROR, {
          context: this.context,
          errorCategory: "Failed to set default payment" + err
        });
      }
    },

    async doSavePayment(p) {
      if (!this.withAddress ||
              (this.showAddNewPayment && this.$refs.addAddressForm.validate()) ||
              (this.showEditPayment && this.$refs.editAddressForm.validate())) {
        this.savePaymentProcessing = true;
        // The save button is always enabled. Validate form before continuing.
        let isFormValid;

        if (this.emptyPaymentFormName(this.selectedPaymentType)) {
          isFormValid = true;
          // Set default values for non credit card type to save
          p = {
            paymentTypeId: this.selectedPaymentType,
            cardHolderName: this.selectedPaymentTypeLocalizedName
          };
        } else if (this.showAddNewPayment && !this.showEditPayment) {
          switch (this.selectedPaymentType) {
            case PaymentType.CEDN:
              isFormValid = this.$refs.cedynaForm.validate();
              break;
            case PaymentType.SDD:
              isFormValid = this.$refs.sepaForm.validate();
              p.paymentTypeId = this.selectedPaymentType;
              p.cardHolderName = this.accountHolderName;
              break;
            default:
              isFormValid = this.$refs.addCreditCardForm.validate();
          }
        } else {
          if (this.selectedPaymentType === PaymentType.CBLU) {
            isFormValid = this.$refs.editCarteBleueForm.validate();
          } else {
            isFormValid = this.$refs.editCreditCardForm.validate();
          }
        }

        if (isFormValid) {
          let paymentData = {
            ...this.getPaymentData(p, this.setAsDefault, false),
            ...this.getBillingAddress(this.addressFormData, false)
          };
          this.editSaveLoading = this.showEditPayment;
          this.saveLoading = this.showAddNewPayment;
          if (typeof p.bePaymentTypeId === 'number' && p.bePaymentTypeId > 0) {
            paymentData.bePaymentTypeId = p.bePaymentTypeId;
            try {
              const editMethod = this.showEditPayment ? 'editPaymentCheckbox' : this.showAddNewPayment ? 'addPaymentCheckbox' : 'defaultMenuOption';
              await this.editPayment(paymentData, editMethod);
              this.cleanupAddEditPayment(paymentData);
            } catch (err) {
              this.editSaveLoading = this.saveLoading = false;
              this.savePaymentProcessing = false;
              this.addToAlerts();
              events.tag(PAYMENTERROR, {
                context: this.context,
                errorCategory: 'Failed to edit payment: ' + err
              });
            }
          } else {
            try {
              if (typeof p.bePaymentTypeId === 'number' && p.bePaymentTypeId < 0) {
                // Was previously created but not saved to profile. Now the
                // user wants to save it off of an edit. Need to delete it
                // from payments because it will be added to the list again.

                await this.deletePayment(p.bePaymentTypeId, true);
                paymentData.bePaymentTypeId = null;
              }
              const editMethod = this.addMethod ? this.addMethod : "firstPayment";
              this.selectedPaymentId = await this.addPayment(paymentData, editMethod, this.agreeToSave);
              this.cleanupAddEditPayment(paymentData);
              this.showState(SELECT_PAYMENT_STATE);
            } catch (err) {
              this.editSaveLoading = this.saveLoading = false;
              this.savePaymentProcessing = false;
              this.addToAlerts();
              events.tag(PAYMENTERROR, {
                context: this.context,
                errorCategory: "Failed to add payment: " + err
              });
            }
          }
        } else {
          this.savePaymentProcessing = false;
        }
      } else {
        this.editingBillingAddress = true;
      }
    },

    clearStateFlags() {
      this.showComplete = false;
      this.showSelectedPayment = false;
      this.showSavedPayments = false;
      this.showEditPayment = false;
      this.showAddNewPayment = false;
      this.clearAlerts();
    },

    showState(section) {
      let switchedState = false;

      switch (section) {
        case COMPLETE_STATE:
          if (!this.showComplete) {
            this.clearStateFlags();
            this.showComplete = true;
            switchedState = true;
          }
          break;
        case COLLAPSED_STATE:
          if (!this.showSelectedPayment) {
            this.clearStateFlags();
            this.showSelectedPayment = true;
            switchedState = true;
          }
          break;
        case SELECT_PAYMENT_STATE:
          if (!this.showSavedPayments) {
            this.clearStateFlags();
            this.showSavedPayments = true;
            switchedState = true;
          }
          break;
        case EDIT_PAYMENT_STATE:
          if (!this.showEditPayment) {
            this.clearStateFlags();
            this.showEditPayment = true;
            switchedState = true;
          }
          break;
        case ADD_PAYMENT_STATE:
          if (!this.showAddNewPayment) {
            this.clearStateFlags();
            this.showAddNewPayment = true;
            switchedState = true;
          }
          break;
      }

      return switchedState;
    },

    cleanupAddEditPayment(payment) {
      this.editSaveLoading = this.saveLoading = false;
      if (payment) {
        this.setExtraFieldsOnPayment(payment.bePaymentTypeId);
        if (payment.defaultPayment) {
          this.updateDefaultPaymentOrder();
        }
      }
      // Cleanup
      this.showState(SELECT_PAYMENT_STATE);
      this.resetForms();
      this.currentEditedPayment = {};
      this.formData = {};
      this.addressFormData = null;
      this.agreeToSave = false;
      this.savePaymentProcessing = false;
      let paymentWrapper = document.getElementById("paymentWrapper");
      if (paymentWrapper) {
        window.scrollTo(0, paymentWrapper.offsetTop - 60); // 60px accounts for the title displayed by the consuming component
      }
    },

    clearAlerts() {
      this.alerts = [];
    },

    addToAlerts(message = this.t.serverErrorMessage, context = ERROR, title = this.t.serverErrorTitle) {
      if (!this.alerts.find(a => a.type = context && a.message === message)) {
        const errors = this.alerts.filter(a => a.context === ERROR);
        const others = this.alerts.filter(a => a.context !== ERROR);
        const alert = {
          id: Date.now(),
          context: context,
          title: title,
          message: message
        };
        context === ERROR ? errors.push(alert) : others.push(alert);
        this.alerts = others.concat(errors);
      }
    },

    /**
     * Sets complete state for the component and show appropriate view.
     */
    setState(initializing = false) {
      let switchedState = false;
      if (this.payments.length > 0) {
        if (this.selectedPayment) {
          if (this.selectedPayment.cvvRequired) {
            if (this.cvv) {
              this.$emit(CVV, this.cvv);
              this.emitSelectedPayment(this.selectedPayment);
              switchedState = this.showState(COMPLETE_STATE);
            } else {
              switchedState = this.showState(COLLAPSED_STATE);
            }
          } else {
            this.emitSelectedPayment(this.selectedPayment);
            switchedState = this.showState(COMPLETE_STATE);
          }
        } else {
          switchedState = this.showState(SELECT_PAYMENT_STATE);
        }
      } else {
        this.openAddPaymentAndSetPaymentType(this.getFirstAvailablePaymentType(), 'noPayments', initializing);
      }

      if (switchedState) {
        this.$emit(STATE, this.showComplete ? COMPLETE : EDIT);
      }
    },

    openPayments() {
      if (this.payments.length > 0) {
        if (this.selectedPayment) {
          this.selectedPaymentId = this.selectedPayment.bePaymentTypeId;
          this.selectedPayment = null;
        }
        this.setState();
      }
    },

    async setSelectedPayment() {
      let foundPayment = null;
      let value = null;

      try {
        value = this.initialValue ? JSON.parse(this.initialValue) : null;
      } catch (err) {
        console.error(err);
      }

      // bePaymentTypeId's that are < 100 are not saved to profile.  We don't save payment info in
      // localstorage so if it isn't saved to profile the user will have to enter the payment info again.
      if (value && value.bePaymentTypeId && value.bePaymentTypeId > 100) {
        // We need to find the payment since value may not contain all needed payment info
        foundPayment = this.payments.find(p => p.bePaymentTypeId === value.bePaymentTypeId);
        if (!this.hasAvailablePaymentType(foundPayment.paymentTypeId)) {
          // If the payment isn't allowed, clear foundPayment. 
          foundPayment = null;
        }
      }

      // It is possible initialValue was a full payment object so we will try to build found payment if we don't have it
      if (!foundPayment) {
        if (value && typeof value === "object" && this.hasAvailablePaymentType(value.paymentTypeId) &&
          // If the payment passed in is a credit card
          PaymentType.credit.includes(value.paymentTypeId) && value.paymentNumber.length > 4 &&
          value.expMonth && value.expYear) {

          foundPayment = this.payments.find(p => {
            return (
              p.paymentTypeId === value.paymentTypeId &&
              p.paymentName === value.paymentName &&
              p.paymentNumber.substring(p.paymentNumber.length - 4) ===
                value.paymentNumber.substring(value.paymentNumber.length - 4) &&
              p.expMonth === value.expMonth &&
              p.expYear === value.expYear
            );
          });
          if (!foundPayment) {
            const newPayment = {
              ...value,
              bePaymentTypeId: this.addedPaymentId
            };
            const bePaymentTypeId = await this.addPayment(newPayment, 'initialization', false);
            foundPayment = this.payments.find(p => p.bePaymentTypeId === bePaymentTypeId);
          }
        // If the payment passed in is not a credit card
        } else if (value && typeof value === "object" && this.hasAvailablePaymentType(value.paymentTypeId)) {
            foundPayment = this.payments.find(p => p.paymentTypeId === value.paymentTypeId);
            if (!foundPayment) {
              const newPayment = {
                ...value,
                bePaymentTypeId: this.addedPaymentId,
                paymentName: value.paymentName || this.findAvailablePaymentType(value.paymentTypeId).localizedName
              };
              const bePaymentTypeId = await this.addPayment(newPayment, 'initialization', false);
              foundPayment = this.payments.find(p => p.bePaymentTypeId === bePaymentTypeId);
            }
        } else if (this.payments.length > 0) {
          if (this.payments.length === 1 || this.payments[0].defaultPayment) {
            foundPayment = this.payments[0];
          }
        } else {
          if (this.availableCreditTypes.length === 0 && this.availablePaymentTypes.length === 1) {
            // with only one non-credit card type available select the only type left by default
            this.selectedPaymentType = this.getFirstAvailablePaymentType();
            this.agreeToSave = false;
            this.setAsDefault = false;
            await this.doSavePayment({});
            foundPayment = this.payments[0];
          }
        }
      }
      if (foundPayment) {
        this.selectedPayment = foundPayment;
        this.selectedPaymentId = foundPayment.bePaymentTypeId;
      }
    },

    async updateExpirationDate(p, event) {
      if (event.expYear && event.expMonth) {
        p.expYear = event.expYear;
        p.expMonth = event.expMonth;
        try {
          p = await this.editPayment(p);
          this.setExtraFieldsOnPayment(p.bePaymentTypeId);
          if (this.showSelectedPayment) {
            this.selectedPayment = p;
          }
          this.$forceUpdate();
        } catch (err) {
          this.addToAlerts();
          events.tag(PAYMENTERROR, {
            context: this.context,
            errorCategory: 'Failed to update expiration on payment: ' + err
          });
        }
      }
    },

    toggleExpirationDateForm(p) {
      if (p) {
        p.editExpirationDate = !p.editExpirationDate;
        this.$forceUpdate();
      }
    },

    checkOrderTypeIsADR() {
      let adrOrderTypes = ["SHIP IMMEDIATE", "ADR CREATE"];

      let isOrderTypeADR = adrOrderTypes.includes(this.orderType);

      return isOrderTypeADR;
    }
  },

  mounted() {
    // Make sure translations are loaded first
    this.initMixin().finally(()=> {
      this.subscribeToPageChange();

      //console.log('ORDER_PAYMENT_ERROR', events.shop.ORDER_PAYMENT_ERROR);
      events.subscribe('orderPaymentError', error => {
        this.openPayments();
        this.addToAlerts(error.message, error.level, error.level === ERROR ? this.t.error : this.t.warning);
      });
      const scope = this;
      this.getAllPaymentInfo().then(([pmtTypesOk, pmtsOk]) => {
        if (pmtTypesOk && pmtsOk) {
          this.updateDefaultPaymentOrder();
          this.setSelectedPayment().then(() => {
            scope.setState(true);
          });
        } else {
          scope.addToAlerts();
        }
      });
    });
  }
};
</script>

<style lang="scss" module="$x">
@use "./paymentSelector.module.scss";
//TODO a temp fix for a weird issue. removing it start throwing error while unit test.
.dummy {
  color: blue;
}

.sub-header {
  img {
    margin-right: 10px;
  }
}
</style>
<style lang="scss">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@use "~@nuskin/ns-core-styles/src/scss/gridStyles";
@use "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";

@mixin grayscale() {
  filter: grayscale(1);
  opacity: 0.5;
  cursor: initial;
  pointer-events: none;
}

[class^="NsPaymentSelector_"] {

  .title-small-bold {
    @include global.title-small-bold();
  }

  a:not(.v-list__tile__title) {
    color: purple;
    text-decoration: none;
    font-weight: bold;
  }
  a.v-list__tile {
    align-content: center;
    color: inherit;
    display: flex;
    font-size: 16px;
    font-weight: 400;
    height: 48px;
    margin: 0;
    padding: 0 16px;
    position: relative;
    text-decoration: none;
    -webkit-transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    text-transform: none;
  }

  .v-select .v-input__control .v-input__slot {
    border: none;
    padding: 0;

    .v-select__slot {
      flex-flow: column nowrap !important;

      .v-input__append-inner {
        bottom: 7px;
        right: 5px;
        top: auto;
        margin: 0;
        z-index: 100;
        position: absolute;
      }
      .v-select__selections {
        position: relative;

        .v-select__selection--comma {
          margin: 0;
          position: absolute;
          top: 50%;
          left: 20px;
          transform: translateY(-50%);
          z-index: 100;
        }

        input {
          border: 1px solid #bbbcbc;

          &:focus {
            box-shadow: 0 0 5px 2px rgba(113, 35, 217, 0.2);
          }
        }
      }
      label.primary--text {
        color: map.get(colors.$baseColors, "blackhole") !important;
        font-size: 16px;
        font-family: "proxima-nova", sans-serif;
      }
      svg {
        color: map.get(colors.$baseColors, "blackhole") !important;
      }
    }
  }

  .saved-payment {
    width: 100%;
  }

  .v-menu__content.menuable__content__active.pop-menu {
    min-width: 300px !important;
    border: 3px solid map.get(colors.$baseColors, "dryink") !important;
    overflow: hidden;
  }

  .v-menu__content {
    z-index: 101 !important;
  }

  .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
    align-items: center;

    label {
      margin-bottom: 0;
    }
  }

  .v-label {
    font-family: map.get(
      typographyVariables.$typography,
      "font-family-primary"
    );
  }

  .v-radio {
    justify-content: flex-start;

    .v-icon.accent--text {
      color: map.get(colors.$baseColors, "shells") !important;
    }
  }

  .v-radio--is-disabled {
    .v-label {
      color: map.get(colors.$baseColors, "eyore");
    }
  }

  .v-input--radio-group {
    .v-input__control {
      width: 100%;
    }
  }

  .v-input--radio-group {
    .v-input__control {
      width: 100%;
    }
  }

  .radio-option {
    display: flex;
    justify-content: flex-start;
    cursor: pointer;
    .label {
      margin-left: -22px;
    }
  }

  .v-input--checkbox {
    .v-icon {
      font-size: 30px;
    }

    .v-messages {
      min-height: 0;
    }
  }

  .title {
    @extend .title;
  }

  .title-small-bold {
    @extend .title-small-bold;
  }

  .v-menu__content.pop-menu .v-list__tile__title,
  .v-menu__content.pop-menu .v-list__tile__avatar {
    color: map.get(colors.$baseColors, "shells");
  }

  .v-input--selection-controls__input {
    width: 30px;
    height: 30px;
    padding-top: 3px;
  }

  .v-input--selection-controls {
    padding-top: 0;
    margin-top: 10px;
  }

  .v-radio--is-disabled + .card-icons img {
    @include grayscale();
  }
}

.delete-confirmation {
  .title-small-bold {
    margin-bottom: 22px;
    justify-content: center;
  }

  .v-card__actions {
    justify-content: flex-end;

    button:first-child {
      margin-right: 20px;

      &:focus {
        outline: none;
      }
    }

    .alert-solid {
      min-width: 175px;
      text-transform: none !important;
    }

    @media screen and (max-width: gridStyles.$phone) {
      flex-flow: column-reverse;

      button {
        width: 100%;

        &:first-child {
          margin-right: 0;
        }

        &:nth-child(2) {
          margin-bottom: 10px;
        }
      }
    }
  }
}

[class*="__nsAddressForm"] {
  @import "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";
}

.no-scroll-x {
  overflow-x: hidden;
}
</style>
